<mat-card>
  <mat-card-header>
    <mat-card-title>
      <h2>Encsi & Máté</h2>
      <h4>Itt követhetitek élőben az esküvő szertartást:</h4>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="stream-wrapper" *ngIf="streamAvailable">
      <div class='stream-player'>
        <iframe [src]="safeStreamUrl" allowfullscreen allow="autoplay"></iframe>
      </div>
    </div>
    <div class="stream-placeholder" *ngIf="!streamAvailable">
      <p>A közvetítés még nem indult el, a szertartás 2020.11.14.-én 12:00-kor kezdődik.</p>
    </div>
  </mat-card-content>
</mat-card>
